import { Toast } from 'vant'
import regex from '@/configs/regex.js'

export default {
    name: 'AuthPage',
    data() {
        return {
            name: '',
            idcard: ''
        }
    },
    methods: {
        submit() {
            if (! this.name || this.name.length < 2 || this.name.length > 5) {
                Toast('请输入正确的姓名');
            } else if (! regex.idcard.test(this.idcard)) {
                Toast('请输入正确的身份证号');
            } else {
                this.$http.put('user/info', {name: this.name, idcard: this.idcard}).then((result) => {
                    this.$store.commit('setUser', result.data.user);
                    this.$router.replace(this.$route.query.back ? this.$route.query.back : '/personal');
                })
            }
        }
    }
}